import { MapPin, Clock, Instagram } from "lucide-react";
import { BRAND_NAME, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "../data/site";

const MAPS_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=Via+Crocevecchia+21,+66010+Tollo+CH";
const MAPS_EMBED =
  "https://www.google.com/maps?q=Via+Crocevecchia+21,+66010+Tollo+CH&output=embed";

export const VisitUs = () => {
  return (
    <section id="dove-trovarci" data-testid="visit-us-section" className="py-24 max-w-6xl mx-auto px-6 border-t border-ink/10">
      <div className="mb-12">
        <p className="text-xs uppercase tracking-[0.16em] text-cognac font-semibold mb-2">
          Il Negozio
        </p>
        <h2 className="font-display sec-title font-normal text-ink">Vieni a trovarci</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-stretch">
        <div className="md:col-span-5 space-y-6">
          <div className="p-6 rounded-2xl bg-cream border border-ink/10 space-y-2">
            <div className="flex items-center gap-3 text-cognac">
              <MapPin className="w-5 h-5" aria-hidden="true" />
              <h3 className="font-display text-xl font-semibold text-ink">Indirizzo</h3>
            </div>
            <p data-testid="shop-address" className="text-sm text-ink/80 leading-relaxed">
              Via Crocevecchia 21<br />
              66010 Tollo (CH)
            </p>
            <a
              href={MAPS_DIRECTIONS}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="directions-link"
              className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-cognac hover:text-ink transition-colors"
            >
              <span>Indicazioni stradali</span>
              <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
          <div className="p-6 rounded-2xl bg-cream border border-ink/10 space-y-2">
            <div className="flex items-center gap-3 text-cognac">
              <Clock className="w-5 h-5" aria-hidden="true" />
              <h3 className="font-display text-xl font-semibold text-ink">Orari di apertura</h3>
            </div>
            <p data-testid="shop-hours" className="text-sm text-ink/80 leading-relaxed">
              09:00 – 12:30<br />
              16:30 – 20:00
            </p>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-link"
            className="flex items-center gap-4 p-6 rounded-2xl bg-ink text-bone hover:bg-cognac transition-colors group"
          >
            <Instagram className="w-8 h-8 shrink-0" aria-hidden="true" />
            <div>
              <p className="font-display text-lg font-semibold">I nuovi arrivi ogni giorno</p>
              <p className="text-xs text-bone/70 group-hover:text-white/80 transition-colors">
                Segui {INSTAGRAM_HANDLE} su Instagram
              </p>
            </div>
            <span className="ml-auto text-lg" aria-hidden="true">&rarr;</span>
          </a>
        </div>
        <div className="md:col-span-7">
          <div className="h-full min-h-[320px] rounded-2xl overflow-hidden border border-ink/10 shadow-sm">
            <iframe
              title={`Mappa: ${BRAND_NAME}, Via Crocevecchia 21, Tollo`}
              data-testid="map-embed"
              src={MAPS_EMBED}
              className="w-full h-full min-h-[320px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};
